export const actionVerbsByCategory: Record<string, string[]> = {
  leadership: [
    'Spearheaded',
    'Directed',
    'Orchestrated',
    'Championed',
    'Oversaw',
    'Mobilized',
    'Pioneered',
    'Steered',
    'Commanded',
    'Guided',
    'Mentored',
    'Supervised',
    'Delegated',
    'Governed',
    'Headed',
    'Inspired',
    'Led',
    'Managed',
    'Motivated',
    'Navigated',
    'Rallied',
    'Shaped',
    'Unified',
    'Empowered',
    'Established',
    'Founded',
    'Initiated',
    'Launched',
  ],
  achievement: [
    'Achieved',
    'Surpassed',
    'Exceeded',
    'Attained',
    'Earned',
    'Delivered',
    'Accomplished',
    'Outperformed',
    'Completed',
    'Realized',
    'Won',
    'Secured',
    'Captured',
    'Generated',
    'Produced',
    'Reached',
    'Boosted',
    'Elevated',
    'Strengthened',
    'Amplified',
    'Doubled',
    'Tripled',
    'Gained',
    'Improved',
    'Increased',
    'Advanced',
  ],
  communication: [
    'Articulated',
    'Presented',
    'Negotiated',
    'Persuaded',
    'Advocated',
    'Authored',
    'Briefed',
    'Collaborated',
    'Communicated',
    'Conveyed',
    'Corresponded',
    'Counseled',
    'Drafted',
    'Edited',
    'Facilitated',
    'Influenced',
    'Liaised',
    'Mediated',
    'Moderated',
    'Promoted',
    'Publicized',
    'Reconciled',
    'Translated',
    'Clarified',
    'Documented',
    'Reported',
  ],
  technical: [
    'Engineered',
    'Developed',
    'Architected',
    'Automated',
    'Built',
    'Coded',
    'Configured',
    'Debugged',
    'Deployed',
    'Designed',
    'Digitized',
    'Implemented',
    'Integrated',
    'Migrated',
    'Modernized',
    'Optimized',
    'Programmed',
    'Prototyped',
    'Refactored',
    'Resolved',
    'Scaled',
    'Standardized',
    'Tested',
    'Upgraded',
    'Virtualized',
    'Maintained',
  ],
  analysis: [
    'Analyzed',
    'Evaluated',
    'Assessed',
    'Audited',
    'Benchmarked',
    'Calculated',
    'Compared',
    'Diagnosed',
    'Discovered',
    'Examined',
    'Forecasted',
    'Identified',
    'Interpreted',
    'Investigated',
    'Mapped',
    'Measured',
    'Modeled',
    'Monitored',
    'Projected',
    'Quantified',
    'Researched',
    'Reviewed',
    'Surveyed',
    'Tracked',
    'Validated',
    'Verified',
  ],
  creative: [
    'Designed',
    'Innovated',
    'Conceptualized',
    'Crafted',
    'Created',
    'Customized',
    'Devised',
    'Envisioned',
    'Fashioned',
    'Formulated',
    'Illustrated',
    'Imagined',
    'Introduced',
    'Invented',
    'Originated',
    'Reimagined',
    'Rebranded',
    'Revamped',
    'Revitalized',
    'Styled',
    'Transformed',
    'Visualized',
    'Curated',
    'Produced',
    'Composed',
    'Shaped',
  ],
  operations: [
    'Streamlined',
    'Optimized',
    'Consolidated',
    'Coordinated',
    'Accelerated',
    'Centralized',
    'Eliminated',
    'Executed',
    'Expedited',
    'Improved',
    'Overhauled',
    'Processed',
    'Reduced',
    'Reorganized',
    'Restructured',
    'Simplified',
    'Systematized',
    'Standardized',
    'Strengthened',
    'Transformed',
    'Upgraded',
    'Enhanced',
    'Refined',
    'Automated',
    'Implemented',
    'Administered',
  ],
  financial: [
    'Budgeted',
    'Forecasted',
    'Maximized',
    'Allocated',
    'Appraised',
    'Audited',
    'Balanced',
    'Capitalized',
    'Conserved',
    'Cut',
    'Decreased',
    'Economized',
    'Financed',
    'Funded',
    'Generated',
    'Invested',
    'Leveraged',
    'Minimized',
    'Netted',
    'Procured',
    'Profited',
    'Recouped',
    'Reduced',
    'Saved',
    'Secured',
    'Yielded',
  ],
};

export const allActionVerbs: string[] = [
  ...new Set(Object.values(actionVerbsByCategory).flat()),
];
